import React from 'react';

const OPTIONS = [
  {
    id: 'all',
    label: 'All Formats',
    desc: 'Masked letter + summary + watermark.',
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="17" x2="12" y2="21"/>
      </svg>
    ),
  },
  {
    id: 'watermark',
    label: 'Watermarked',
    desc: 'Masked letter + summary + watermark.',
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
      </svg>
    ),
  },
  {
    id: 'masked',
    label: 'Masked',
    desc: 'Masked letter + summary (no watermark).',
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
        <line x1="1" y1="1" x2="23" y2="23"/>
      </svg>
    ),
  },
  {
    id: 'standard',
    label: 'Standard',
    desc: 'Masked letter + summary (no watermark).',
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
        <polyline points="14 2 14 8 20 8"/>
        <line x1="16" y1="13" x2="8" y2="13"/>
        <line x1="16" y1="17" x2="8" y2="17"/>
        <polyline points="10 9 9 9 8 9"/>
      </svg>
    ),
  },
];

const styles = {
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: 10,
    marginBottom: 24,
  },
  option: {
    border: '1px solid var(--border)',
    borderRadius: 'var(--radius-md)',
    padding: '16px 14px',
    cursor: 'pointer',
    transition: 'all 0.15s ease',
    background: 'transparent',
    textAlign: 'left',
    color: 'var(--text-secondary)',
  },
  optionSelected: {
    border: '2px solid var(--blue)',
    background: 'var(--brand-dim)',
    boxShadow: '0 0 0 3px rgba(38, 119, 255, 0.1)',
  },
  optionIcon: {
    marginBottom: 10,
    display: 'block',
  },
  optionLabel: {
    fontFamily: 'var(--font-display)',
    fontWeight: 600,
    fontSize: 13,
    marginBottom: 4,
    display: 'block',
  },
  optionDesc: {
    fontFamily: 'var(--font-mono)',
    fontSize: 11,
    lineHeight: 1.5,
    display: 'block',
    color: 'var(--text-tertiary)',
  },
};

export default function OutputOptions({ selected, onChange, sectionLabel = 'output type' }) {
  return (
    <div>
      <div className="section-label">{sectionLabel}</div>
      <div style={styles.grid}>
        {OPTIONS.map(opt => {
          const isSelected = selected === opt.id;
          return (
            <button
              key={opt.id}
              style={{
                ...styles.option,
                ...(isSelected ? styles.optionSelected : {}),
              }}
              onClick={() => onChange(opt.id)}
              onMouseOver={e => {
                if (!isSelected) e.currentTarget.style.borderColor = 'var(--border-active)';
              }}
              onMouseOut={e => {
                if (!isSelected) e.currentTarget.style.borderColor = 'var(--border)';
              }}
            >
              <span style={{
                ...styles.optionIcon,
                color: isSelected ? 'var(--brand)' : 'var(--text-tertiary)',
              }}>
                {opt.icon}
              </span>
              <span style={{
                ...styles.optionLabel,
                color: isSelected ? 'var(--text-heading)' : 'var(--text-primary)',
              }}>
                {opt.label}
              </span>
              <span style={styles.optionDesc}>{opt.desc}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
